import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5410fb7f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "catalogue"
};
import { ref, watch, onMounted } from 'vue';
import { addIndex } from '@/utils/common';
import CatalogueItem from './CatalogueItem.vue';
export default {
  __name: 'index',
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  setup(__props) {
    const props = __props;
    const newList = ref([]);
    const changeList = val => {
      newList.value = val;
      addIndex(newList.value);
    };
    watch(() => props.list, val => {
      changeList(val);
    });
    onMounted(() => {
      changeList(props.list);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newList.value, (l, index) => {
        return _openBlock(), _createBlock(CatalogueItem, {
          item: l,
          key: l.id,
          index: index
        }, {
          content: _withCtx(content => [_renderSlot(_ctx.$slots, "content", _normalizeProps(_guardReactiveProps(content)))]),
          _: 2
        }, 1032, ["item", "index"]);
      }), 128))]);
    };
  }
};